// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3BS5F","box":"WorkspacesBox_box__1_dKH","node":"WorkspacesBox_node__td4-4"};